<!-- components/base/casino/BaseProvider.vue -->
<script setup lang="ts">
import { useSettingsStore } from "~/stores/settings";

const settingsStore = useSettingsStore();
const settings = settingsStore.settings;

interface ProviderData {
  slug: string;
  name: string;
  aggregator: string;
  image: string;
  custom_image?: string;
  degrade_image?: string;
}

const props = defineProps({
  data: {
    type: Object as () => ProviderData,
    default: () => ({}),
    required: false
  },
  shimmer: {
    type: Boolean,
    default: false
  }
});

const data = ref(props.data);

const validator = () => {
  if (props.shimmer) {
    return true;
  }
  return data.value !== null && data.value !== undefined;
};

watch(
  () => props.data,
  (newVal) => {
    data.value = newVal;
  }
);

const display = isMobileDevice() ? "mobile" : "desktop";

const backgroundImage = computed(() => {
  return `url('${data.value.image_cf ? data.value.image_cf + display : (settings.general_degrade_effect && data.value.degrade_image ? data.value.degrade_image : data.value.custom_image ?? data.value.image)}')`;
});

watch(() => props.shimmer, validator);
</script>

<template>
  <div
    class="flex aspect-[18/10] rounded-md min-w-[calc(50vw-1.8rem)] xs:min-w-[calc(33.33vw-1.6rem)] sm:min-w-[calc(25vw-1.4rem)] md:min-w-[calc(20vw-1.6rem)] lg:min-w-[calc(16.6666666667vw-4.5rem)] xl:min-w-[162px] bg-brand-card">
    <!-- Shimmer -->
    <div
      v-if="shimmer"
      class="shimmer-effect group relative flex h-full w-full cursor-pointer flex-col rounded-md"
    />

    <!-- Card -->
    <div
      v-else
      class="group relative flex w-full cursor-pointer flex-col rounded-md"
    >
      <NuxtLink
        :to="{ path: `/providers/${data.slug}` }"
        class="w-full h-full cursor-pointer"
      >
        <!-- Card image -->
        <div
          :style="{ backgroundImage: backgroundImage }"
          class="rounded-md h-full bg-contain bg-no-repeat bg-blend-darken"
        ></div>
        <!-- End card image -->
        <!-- Card text -->
        <div
          class="bg-full pointer-events-none absolute bottom-0 z-20 w-full items-end rounded-b-md hidden"
        >
          <div class="flex w-full select-none flex-col p-2 text-white">
            <p
              class="overflow-hidden overflow-ellipsis whitespace-nowrap text-xs font-bold leading-none tracking-tight sm:text-sm"
            >
              {{ data.name }}
            </p>
            <p class="text-xss sm:text-xs">
              {{ data.aggregator }}
            </p>
          </div>
        </div>
        <!-- End card text -->

        <!-- Handle hover -->
        <div
          class="absolute rounded-md left-0 top-0 z-10 flex w-full h-full cursor-pointer items-center justify-center bg-black/40 opacity-0 transition-all group-hover:opacity-100"
        >
          <BaseButton variant="primary" size="xs" class="font-bold">
            Ver jogos
          </BaseButton>
        </div>
        <!-- End hover -->
      </NuxtLink>
    </div>
  </div>
</template>
